import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { API, toast } from '@/App';
import axios from 'axios';
import { FileEdit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

const AdminPages = () => {
  const pages = [
    { name: 'home', label: 'Ana Sayfa' },
    { name: 'about', label: 'Hakkımızda' },
  ];

  const [selectedPage, setSelectedPage] = useState('home');
  const [pageContent, setPageContent] = useState({});
  const [formData, setFormData] = useState({
    hero_title: '',
    hero_description: '',
    about_text: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedPage) {
      fetchPageContent(selectedPage);
    }
  }, [selectedPage]);

  const fetchPageContent = async (pageName) => {
    try {
      const response = await axios.get(`${API}/pages/${pageName}`);
      setPageContent(response.data.content || {});
      setFormData(response.data.content || {});
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${API}/pages/${selectedPage}`, {
        page_name: selectedPage,
        content: formData,
      });
      toast.success('Sayfa içeriği güncellendi!');
    } catch (error) {
      toast.error('Bir hata oluştu!');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-pages-page">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Sayfa İçerikleri</h1>
          <p className="text-white/60">Sayfa içeriklerini düzenleyin</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Page Selector */}
          <div className="lg:col-span-1">
            <div className="glass p-4 rounded-2xl space-y-2">
              {pages.map((page) => (
                <button
                  key={page.name}
                  onClick={() => setSelectedPage(page.name)}
                  data-testid={`select-page-${page.name}`}
                  className={`w-full text-left px-4 py-3 rounded-lg transition-colors ${
                    selectedPage === page.name
                      ? 'bg-gradient-to-r from-[#FF6B35] to-[#F7931E]'
                      : 'hover:bg-white/5'
                  }`}
                >
                  <FileEdit className="w-4 h-4 inline mr-2" />
                  {page.label}
                </button>
              ))}
            </div>
          </div>

          {/* Content Editor */}
          <div className="lg:col-span-3">
            <div className="glass p-6 rounded-2xl">
              <form onSubmit={handleSubmit} className="space-y-4">
                {selectedPage === 'home' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium mb-2">Hero Başlık</label>
                      <Input
                        value={formData.hero_title || ''}
                        onChange={(e) => setFormData({ ...formData, hero_title: e.target.value })}
                        placeholder="Ana sayfa başlık"
                        className="bg-white/5 border-white/10 text-white"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2">Hero Açıklama</label>
                      <Textarea
                        value={formData.hero_description || ''}
                        onChange={(e) => setFormData({ ...formData, hero_description: e.target.value })}
                        placeholder="Ana sayfa açıklama"
                        rows={3}
                        className="bg-white/5 border-white/10 text-white"
                      />
                    </div>
                  </>
                )}
                {selectedPage === 'about' && (
                  <div>
                    <label className="block text-sm font-medium mb-2">Hakkımızda Metni</label>
                    <Textarea
                      value={formData.about_text || ''}
                      onChange={(e) => setFormData({ ...formData, about_text: e.target.value })}
                      placeholder="Hakkımızda sayfası içeriği"
                      rows={10}
                      className="bg-white/5 border-white/10 text-white"
                    />
                  </div>
                )}
                <Button
                  type="submit"
                  disabled={loading}
                  data-testid="save-page-content"
                  className="bg-gradient-to-r from-[#FF6B35] to-[#F7931E]"
                >
                  {loading ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminPages;